module.exports = ".ssf-message {\n  margin: 1rem 0 -1rem; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/messages/messages.component.scss
// module id = 606
// module chunks = 3